import React, { useLayoutEffect, useRef, useState } from "react";
import ElementMenu from "./ElementMenu";

const identifiant = (nom) =>
  "menu-groupe-" +
  String(nom)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

// Un groupe d'entrées. En rail : bouton icône + volet blanc à côté du menu
// (ouvert au clic ou au survol, par-dessus le contenu). En épinglé et en
// tiroir : accordéon indenté sous la tête du groupe.
const GroupeMenu = ({
  groupe,
  mode,
  ouvert,
  contientActif,
  onBasculer,
  onSurvoler,
  onQuitter,
}) => {
  const rail = mode === "rail";
  const id = identifiant(groupe.name);
  const refLi = useRef(null);
  const refBouton = useRef(null);
  const refVolet = useRef(null);
  // Le volet s'aligne sur le bas du groupe quand il dépasserait l'écran.
  const [versLeHaut, setVersLeHaut] = useState(false);

  useLayoutEffect(() => {
    if (!rail || !ouvert || !refVolet.current || !refLi.current) {
      setVersLeHaut(false);
      return;
    }
    const hauteur = refVolet.current.offsetHeight;
    const haut = refLi.current.getBoundingClientRect().top;
    setVersLeHaut(hauteur > 0 && haut - 4 + hauteur > window.innerHeight - 8);
  }, [rail, ouvert]);

  const classes = [
    "menu-lateral__groupe",
    ouvert ? "menu-lateral__groupe--ouvert" : "",
    contientActif ? "menu-lateral__groupe--actif" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const surClavier = (evenement) => {
    // Le hook referme sur Échap (écouteur document) ; on ramène le focus sur la
    // tête du groupe pour ne pas le perdre avec le volet.
    if (evenement.key === "Escape" && ouvert && refBouton.current) refBouton.current.focus();
  };

  const entrees = groupe.items.map((it) => <ElementMenu key={it.path} item={it} sousEntree />);

  return (
    <li
      ref={refLi}
      className={classes}
      onMouseEnter={rail ? () => onSurvoler(groupe.name) : undefined}
      onMouseLeave={rail ? onQuitter : undefined}
      onKeyDown={surClavier}
    >
      <button
        ref={refBouton}
        type="button"
        className="menu-lateral__groupe-tete"
        aria-expanded={ouvert}
        aria-controls={id}
        title={rail ? groupe.name : undefined}
        onClick={() => onBasculer(groupe.name)}
      >
        <i className={`fa fa-${groupe.icon}`} aria-hidden="true" />
        <span className="menu-lateral__libelle">{groupe.name}</span>
        <i className="fa fa-chevron-down menu-lateral__chevron" aria-hidden="true" />
      </button>
      {rail ? (
        ouvert && (
          <div
            ref={refVolet}
            id={id}
            className={"menu-lateral__volet" + (versLeHaut ? " menu-lateral__volet--vers-le-haut" : "")}
            role="group"
            aria-label={groupe.name}
          >
            <div className="menu-lateral__volet-titre" aria-hidden="true">
              {groupe.name}
            </div>
            <ul>{entrees}</ul>
          </div>
        )
      ) : (
        <ul id={id} className="menu-lateral__sous-liste" hidden={!ouvert}>
          {entrees}
        </ul>
      )}
    </li>
  );
};

export default GroupeMenu;
